import React, { FunctionComponent } from 'react';

import {
  default as MuiTypography,
  TypographyProps,
} from '@mui/material/Typography';

const Typography: FunctionComponent<TypographyProps<React.ElementType>> = (
  props: TypographyProps<React.ElementType>
) => {
  return <MuiTypography {...props}>{props.children}</MuiTypography>;
};

export default Typography;
